export default __webpack_public_path__ + "static/media/atilla-icon.73f6124c.svg";